import React from "react";
import "./About.css";
import Aboutpic from "../../assests/Aboutpic.jpeg";
import { FaGraduationCap } from "react-icons/fa";
import { RiNewspaperFill } from "react-icons/ri";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Aboutpic} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <RiNewspaperFill className="about__icon" />
              <h5>Experience</h5>
              <small>5+ Years Working As Student</small>
            </article>

            <article className="about__card">
              <FaGraduationCap className="about__icon" />
              <h5>Education</h5>
              <small>B.Tech Information Technology</small>
            </article>

            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>25+ Completed 2 Running</small>
            </article>
          </div>

          <p>
            Software Engineer with a demonstrated history of working in the
            non-profit organization management industry. Skilled in C/C++, PHP,
            Python, Java and React. Strong engineering professional with a
            B.TECH focused in Information Technology from CHAROTAR UNIVERSITY OF
            SCIENCE AND TECHNOLOGY.
          </p>

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
